import { HttpClient } from "../HttpClient";
/**
 * * Delete Asset
 */
export const DeleteAsset = async (id) => {
    try {
        const { data } = await HttpClient.delete(`api/pexassets/${id}`);
        return await Promise.resolve(data);
    } catch (err) {
        return Promise.reject(err);
    }
};
